import Vue from 'vue'
import App from '@/App.vue'
import './plugins/element.js'
import '@/styles/reset.css'
import '@/styles/global.scss'
import router from '@/router'
import '@/router/routerHandler.js'
import store from '@/store'

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue() //全局事件总线

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
